import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import NameModal from "../../../components/UI/modal/NameModal";
import UtilityHelpService from "../../../API/admin/UtiltyHelpServices";
import UtilityNewsService from "../../../API/admin/UtilityNewsService";
import UtilityPromotionService from "../../../API/admin/UtilityPromotionService";

const ThemeHelp = ({itemId, handleModalAlert}) => {
    const pathname = useLocation().pathname
    const api = itemId === "themeHelp" ? UtilityHelpService : itemId === "themeNews" ? UtilityNewsService : UtilityPromotionService
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getStartPageSize()
        api.getTheme().then(function (response) {
            setData(response.data);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [itemId]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(null)
    }

    const handleUpdate = (data) => {
        setLoading(true)
        api.updateTheme({title: data.name}, currentEditRowData.id)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                handleClose()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    const handleDelete = (row) => {
        api.deleteTheme(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const handleSubmit = ({name}) => {
        setLoading(true)
        api.addTheme({title: name})
            .then(function (response) {
                setData(prev => [...prev, response.data])
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))

    }

    const handleAdd = () => {
        setModal(true)
    }
    const handleEdit = (row) => {
        setCurrentEditRowData({...row, name: row.title});
        setModal(true)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'title', minSize: 720,
            },
        ]

        return baseColumns;

    }, [data]);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (<div>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>Темы</Typography>
            <ButtonCreate
                text={"Добавить тему"}
                width={170}
                onClick={handleAdd}
            />
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '800px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "36px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions,}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })
            }
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        <NameModal
            title={currentEditRowData ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            loading={loading}/>
    </div>);
};

export default ThemeHelp;
